import "./EditLocationAccessModal.scss";
import { useEffect, useState } from "react";
import { Checkbox, Modal } from "antd";
import { Button } from "../misc/Button";
import { MemberDto } from "../../../generated/account-client";
import { Spinner } from "../misc/Spinner";
import TeamsApi from "../../../api/TeamsApi";
import AccountsApi from "../../../api/AccountsApi";
import { CloseOutlined } from "@ant-design/icons";
import { LocationDto } from "../../../generated/dashboard-client";
// import { CloseOutlined } from "@ant-design/icons";

// const { Option } = Select;

export interface EditLocationAccessModalProps {
  visible: boolean;
  member: MemberDto;
  onCancel: () => void;
  onChange: (member: MemberDto, locations: Set<string>) => void;
}

// const textTooltip = <span>Remove location assignment</span>;

export default function EditLocationAccessModal({
  member,
  visible,
  onCancel,
  onChange,
}: EditLocationAccessModalProps) {
  const [locations, setLocations] = useState([] as LocationDto[]);
  const [locationsOptions, setLocationsOptions] = useState([] as any[]);
  // const [existingLocations, setExistingLocations] = useState([""] as string[]);

  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const [selectedLocations, setSelectedLocations] = useState<string[]>([]);

  useEffect(() => {
    setLoading(true);
    if (!visible || !member) return;

    setEmail(member.email || "");

    TeamsApi.getLocations(member.teamId || "").then((resp) => {
      setLocations(resp.data);

      const options = [] as any[];

      resp.data.forEach(l => {
        options.push({ label: l.name, value: l.id })
      });

      setLocationsOptions(options);

      AccountsApi.getUserLocations(member.id || "").then((resp) => {
        let allIds = Array.from(resp.data?.values()).map((it) => it.id);
        let uniqueIds: string[] = [];
        allIds.forEach((id) => {
          if (!uniqueIds.includes(id!)) {
            uniqueIds.push(id!);
          }
        });

        if (!uniqueIds.length) {
          uniqueIds.push("");
        }
        // setExistingLocations(uniqueIds);
        setSelectedLocations(uniqueIds);
        setLoading(false);
      });
    });
  }, [member, visible]);

  // function addLocation() {
  //   setExistingLocations([...existingLocations, locations[0].id || ""]);
  // }

  // function deleteLocation(idx: number) {
  //   const newSelected = [...existingLocations];
  //   newSelected.splice(idx, 1);
  //   setExistingLocations(newSelected);
  // }

  // function onLocationChange(value: SelectValue, idx: number) {
  //   if (value === "remove") {
  //     deleteLocation(idx);
  //     return;
  //   }
  //   existingLocations[idx] = value as string;
  //   setExistingLocations([...existingLocations]);
  // }

  const onSelect = (list: any[]) => {
    // console.log(">list: " + list)
    // const selected = locations.filter(location => list.includes(location.id!));
    // console.log(">selected: " + list)
    setSelectedLocations(list);
  };

  function selectAllLocations() {
    let allIds = Array.from(locations.values()).map((it) => it.id);
    let uniqueIds: string[] = [];
    allIds.forEach((id) => {
      if (!uniqueIds.includes(id!)) {
        uniqueIds.push(id!);
      }
    });

    setSelectedLocations(uniqueIds);
  }

  function clearSelectedLocations() {
    setSelectedLocations([]);
  }

  return (
    <Modal
      className={"location-access-modal clean one"}
      visible={visible}
      onCancel={onCancel}
    >
      <header>
        <h2>Select location assignments for</h2>
        <CloseOutlined style={{ position: "absolute", right: 15, top: 15, cursor: "pointer" }} onClick={() => onCancel()} />
      </header>
      <h5>{email}</h5>

      {loading && <Spinner />}

      {!loading && (
        <div className={"locations"}>
          {locations.length > 1 &&
            <Checkbox onChange={selectAllLocations} checked={selectedLocations.length === locations.length}>
              Assign all locations
            </Checkbox>
          }

          <Checkbox.Group options={locationsOptions} value={selectedLocations} onChange={onSelect} />

          {/* {existingLocations.map((it, idx) => (
            <div className={"entry"} key={idx}>
              <Select
                key={idx}
                defaultValue={it ? it : (locations.filter(it => it.primary)[0]?.id ?? locations[0]?.id ?? it)}
                value={it ? it : (locations.filter(it => it.primary)[0]?.id ?? locations[0]?.id ?? it)}
                onChange={(value) => onLocationChange(value, idx)}
              >
                {locations.map((location) => (
                  <Option key={location.id} value={location.id || ""}>
                    {location.name}
                  </Option>
                ))}
              </Select>
              {idx !== 0 && (
                <Tooltip title={textTooltip}>
                  <Button type={"Link"} onClick={() => deleteLocation(idx)}>
                    <CloseOutlined />
                  </Button>
                </Tooltip>
              )}
              {idx === existingLocations.length - 1 &&
                existingLocations.length < locations.length && (
                  <Button
                    type={"LinkPrimary"}
                    size={"Small"}
                    onClick={addLocation}
                  >
                    + Add Another
                  </Button>
                )}
            </div>
          ))} */}
        </div>
      )}
      <footer>
        <Button type={"Cancel"} onClick={() => clearSelectedLocations()} disabled={selectedLocations.length === 0}>
          <span>Clear Selection</span>
        </Button>
        <Button
          disabled={selectedLocations.length === 0}
          type={"Primary"}
          onClick={() => onChange(member, new Set(selectedLocations))}
        >
          <span>Done</span>
        </Button>
      </footer>
    </Modal>
  );
}
